import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DragulaModule } from 'ng2-dragula';
import { TranslateModule } from '@ngx-translate/core';
// Components
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { CustomizerComponent } from './components/customizer/customizer.component';
import { FeatherIconsComponent } from './components/feather-icons/feather-icons.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { ContentComponent } from './components/layout/content/content.component';
import { FullComponent } from './components/layout/full/full.component';
import { LoaderComponent } from './components/loader/loader.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { TapToTopComponent } from './components/tap-to-top/tap-to-top.component';
// Header Elements Components
import { SearchComponent } from './components/header/elements/search/search.component';
import { MegaMenuComponent } from './components/header/elements/mega-menu/mega-menu.component';
import { LanguagesComponent } from './components/header/elements/languages/languages.component';
import { NotificationComponent } from './components/header/elements/notification/notification.component';
import { BookmarkComponent } from './components/header/elements/bookmark/bookmark.component';
import { CartComponent } from './components/header/elements/cart/cart.component';
import { MessageBoxComponent } from './components/header/elements/message-box/message-box.component';
import { MyAccountComponent } from './components/header/elements/my-account/my-account.component';
// Directives
 
import { DisableKeyPressDirective } from './directives/disable-key-press.directive';

import { OnlyAlphabetsDirective } from './directives/only-alphabets.directive';
import { OnlyNumbersDirective } from './directives/only-numbers.directive';
import { ShowOptionsDirective } from './directives/show-options.directive';
// Services
import { ChatService } from './services/chat.service';
import { LayoutService } from './services/layout.service';
import { NavService } from './services/nav.service';
import { TableService } from './services/table.service';
import { NgbdSortableHeader } from './directives/NgbdSortableHeader';
import { DecimalPipe } from '@angular/common';
import { ToDateOnlyPipe } from './_helper/to-date-only.pipe';
import { ToDateLargePipe } from './_helper/to-date-large.pipe';
import { ToNewLineHTMLPipe } from './_helper/to-newlineHTML.pipe';
import { ToDateTimePipe } from './_helper/to-date-time.pipe';
import { TruncatePipe } from './_helper/truncate.pipe';

import { ToTimeOnlyPipe } from './_helper/to-time-only.pipe';
import { NgxHijriGregorianDatepickerModule } from './components/date-picker/ngx-hijri-gregorian-datepicker.module';

import { CorrespondanceDetailsComponent } from './components/correspondance-details/correspondance-details.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgSelectModule } from '@ng-select/ng-select';
import { CaseLogHistoryComponent } from './components/case-log-history/case-log-history.component';
import { CaseAcceptanceComponent } from './components/case-acceptance/case-acceptance.component';
import { SignComponent } from './components/sign/sign.component';
import { DepositOrderComponent } from './components/deposit-order/deposit-order.component';
import { ExternalActionsComponent } from './components/external-actions/external-actions.component';
import { CaseFindComponent } from './components/case-find/case-find.component';
import { GeneralAttachmentComponent } from './components/general-attachment/general-attachment.component';
import { BrowserModule } from '@angular/platform-browser';
import { AccountStatmentComponent } from './components/account-statment/account-statment.component';
import { AddrressesComponent } from './components/addrresses/addrresses.component';
import { ReportInsertEditComponent } from './components/report-insert-edit/report-insert-edit.component';
import { MembersComponent } from './components/members/members.component';
import { ReportDetailsComponent } from './components/report-details/report-details.component';
import { AssignOwnerComponent } from './components/assign-owner/assign-owner.component';
import { RelatedCasesComponent } from './components/related-cases/related-cases.component';
import { CustomToggleThreeComponent } from './components/custom-toggle-three/custom-toggle-three.component';
import { CustomToggleComponent } from './components/custom-toggle/custom-toggle.component';
import { CaseAttachmentIndexComponent } from './components/case-attachment-index/case-attachment-index.component';
import { ProsecutionResponsesComponent } from './components/prosecution-responses/prosecution-responses.component';
import { ProsecutionDecisionComponent } from './components/prosecution-decision/prosecution-decision.component';
import { CommiteResponsesComponent } from './components/commite-responses/commite-responses.component';
import { ScannerComponent } from './components/scanner/scanner.component';
import { ViolationComponent } from './components/violation/violation.component';
import { GoogleMapsModule } from "@angular/google-maps";
import { FactsComponent } from './components/facts/facts.component';
import { SuggestionDecisionComponent } from './components/suggestion-decision/suggestion-decision.component';
import { CaseDecisionComponent } from './components/case-decision/case-decision.component';
import { CasePenalityComponent } from './components/case-penality/case-penality.component';
import { TimelineComponent } from './components/timeline/timeline.component';
import { DelegateComponent } from './components/delegate/delegate.component';
import { PenalitiesComponent } from './components/penalities/penalities.component';
import { ProfileComponent } from './components/profile/profile.component';
import { FactsOnlyComponent } from './components/facts-only/facts-only.component';
import { CompanyViolationComponent } from './components/company-violation/company-violation.component';
import { CheckTypeAttachmentComponent } from './components/check-type-attachment/check-type-attachment.component';
import { DecsionComponent } from './components/decsion/decsion.component';
import { CasePenaltiesComponent } from './components/case-penalties/case-penalties.component';
import { ObjecionDetailsComponent } from './components/objecion-details/objecion-details.component';
import { ReasonsComponent } from './components/reasons/reasons.component';
import { CaseCompaniesComponent } from './components/case-companies/case-companies.component';
import { AjudicationLogHistoryComponent } from './components/ajudication-log-history/ajudication-log-history.component';
import { UserService } from './services/user.service';
import { AdditionRequestComponent } from './components/addition-request/addition-request.component';
import { CaseCategoriesComponent } from './components/case-categories/case-categories.component';



@NgModule({
  declarations: [
        HeaderComponent, ReportDetailsComponent, CustomToggleComponent,
    FooterComponent,
    SidebarComponent,
    ContentComponent,
    BreadcrumbComponent,
    CustomizerComponent,
        FeatherIconsComponent, CustomToggleThreeComponent,
    FullComponent,
    ShowOptionsDirective,
    DisableKeyPressDirective,
    OnlyAlphabetsDirective,
    OnlyNumbersDirective,
    LoaderComponent,
    TapToTopComponent,
    SearchComponent,
    MegaMenuComponent,
    LanguagesComponent,
    NotificationComponent,
    BookmarkComponent,
    CartComponent,
    MessageBoxComponent,
    MyAccountComponent,
    NgbdSortableHeader,
    TruncatePipe,
    CorrespondanceDetailsComponent,CaseFindComponent,AddrressesComponent,ReportInsertEditComponent,
        ToDateOnlyPipe, ToTimeOnlyPipe, ToDateTimePipe, CaseLogHistoryComponent, CaseAcceptanceComponent, SignComponent, DepositOrderComponent, ExternalActionsComponent, GeneralAttachmentComponent, AccountStatmentComponent, MembersComponent, ToNewLineHTMLPipe, ToDateLargePipe, AssignOwnerComponent, RelatedCasesComponent, CustomToggleComponent, CaseAttachmentIndexComponent,
     ProsecutionResponsesComponent, ProsecutionDecisionComponent, CommiteResponsesComponent, ScannerComponent,ViolationComponent, DecsionComponent, CasePenaltiesComponent, ObjecionDetailsComponent
     ,FactsComponent,SuggestionDecisionComponent, CaseDecisionComponent, CasePenalityComponent,TimelineComponent,DelegateComponent, PenalitiesComponent, ProfileComponent, FactsOnlyComponent, CompanyViolationComponent, CheckTypeAttachmentComponent, ReasonsComponent, CaseCompaniesComponent, AjudicationLogHistoryComponent,
    AdditionRequestComponent,CaseCategoriesComponent

 ],
  imports: [
CommonModule,
      RouterModule, 
      FormsModule, 
    ReactiveFormsModule,
    NgSelectModule,PdfViewerModule,
    NgbModule,
    DragulaModule.forRoot(),
      TranslateModule, NgxHijriGregorianDatepickerModule, 
      GoogleMapsModule,
  ],
  providers: [
    NavService,
    ChatService,
    LayoutService,
    TableService,
    DecimalPipe,
    UserService
  ],
  exports: [
    NgbModule,
    FormsModule,
      ReactiveFormsModule, CustomToggleThreeComponent,
    TranslateModule,PdfViewerModule,
    LoaderComponent,
      BreadcrumbComponent, ReportDetailsComponent,
    FeatherIconsComponent,
    TapToTopComponent,
    DisableKeyPressDirective,
    OnlyAlphabetsDirective,
    OnlyNumbersDirective,
    NgbdSortableHeader,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    CustomizerComponent,
    AccountStatmentComponent,
    CorrespondanceDetailsComponent,
      ToDateOnlyPipe, ToTimeOnlyPipe, ToNewLineHTMLPipe,TruncatePipe,
    ToDateTimePipe, NgxHijriGregorianDatepickerModule,CheckTypeAttachmentComponent,
    CaseAcceptanceComponent, CaseLogHistoryComponent,FactsOnlyComponent,
    DepositOrderComponent, ExternalActionsComponent,MembersComponent,RelatedCasesComponent,ProsecutionResponsesComponent, ProsecutionDecisionComponent,CaseAttachmentIndexComponent,CompanyViolationComponent,ObjecionDetailsComponent,
      CaseFindComponent, GeneralAttachmentComponent, AddrressesComponent, ReportInsertEditComponent, ToDateLargePipe,AssignOwnerComponent,CommiteResponsesComponent,ViolationComponent,SuggestionDecisionComponent,TimelineComponent,DelegateComponent,DecsionComponent, PenalitiesComponent,CasePenaltiesComponent,ReasonsComponent,FactsComponent,AjudicationLogHistoryComponent
,CaseCompaniesComponent  ,AdditionRequestComponent,CaseCategoriesComponent
],
})
export class SharedModule { }
